import * as React from 'react';
import './styles.scss';

type ModalButtons = {
  text: string;
  callback: () => void;
};

type ModalContent = {
  title: string;
  body: string;
  buttons: Array<ModalButtons>;
};

const ContactForm = () => {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [url, setUrl] = React.useState('');

  const [activeModal, setActiveModal] = React.useState<ModalContent | null>(null);

  const sendingMessage: ModalContent = {
    title: 'Nachricht wird verschickt...',
    body: 'Ihre Nachricht wird verschickt, bitte haben Sie einen Moment Geduld.',
    buttons: []
  };

  const messageConfirm: ModalContent = {
    title: 'Ihre Nachricht wurde verschickt!',
    body: 'Super! Ihre Nachricht wurde an uns verschickt und Sie solltesten in Kürze eine Bestätigungsmail erhalten!',
    buttons: [{ text: 'Schließen', callback: () => setActiveModal(null) }]
  };
  const messageFail: ModalContent = {
    title: 'Etwas ist schief gelaufen!',
    body: 'Das sollte nicht passieren, aber Ihre Nachricht konnte leider nicht verschickt werden! Bitte versuchen Sie es später noch einmal oder schreiben Sie uns direkt an info@elch.digital',
    buttons: [{ text: 'Schließen', callback: () => setActiveModal(null) }]
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setActiveModal(sendingMessage);
    if (url) return;
    const formData = new FormData();
    formData.append('user_name', name);
    formData.append('email', email);
    formData.append('message', message);

    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState === XMLHttpRequest.DONE) {
        if (xhttp.status === 200) {
          // console.info(xhttp.responseText);
          setActiveModal(messageConfirm);
          setName('');
          setEmail('');
          setMessage('');
        } else if (xhttp.status === 400) {
          console.warn('Error: 400');
        } else {
          console.warn(`Error unexpected response: ${xhttp.responseText}`);
          setActiveModal(messageFail);
        }
      }
    };
    xhttp.open('POST', '/php/contactMail.php');
    xhttp.send(formData);
  };

  return (
    <div className="contactForm" id="contact_form">
      {!activeModal && (
        <div className="inner">
          <h2 className="major">Nehmen Sie Kontakt auf</h2>
          <p>
            Haben wir Ihr Interesse geweckt? Dann schreiben Sie uns einfach, wir freuen uns auf Ihre
            Nachricht und melden uns so schnell wie möglich bei Ihnen zurück!
          </p>
          <form onSubmit={onSubmit}>
            <div className="fields">
              <div className="field">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="field">
                <label htmlFor="message">Nachricht</label>
                <textarea
                  name="message"
                  id="message"
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required></textarea>
              </div>
            </div>
            <div className="field" style={{ display: 'none' }}>
              <label htmlFor="url">Website</label>
              <input
                type="text"
                name="url"
                id="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
              />
            </div>
            <ul className="actions">
              <li>
                <input type="submit" value="Abschicken" />
              </li>
            </ul>
          </form>
          <ul className="contact">
            <li className="icon solid fa-home">ELCh Digital GmbH</li>
            <li style={{ marginTop: 0 }}>Gronauer Straße 89</li>
            <li style={{ marginTop: 0 }}>48607 Ochtrup</li>
            <li className="icon solid fa-phone">
              <a href="tel:+4925539771950">+49 2553 9771 950</a>
            </li>
            <li className="icon solid fa-envelope">
              <a href="mailto:info@elch.digital">info@elch.digital</a>
            </li>
            {/* <li className="icon brands fa-twitter">
            <a href="#">twitter.com/untitled-tld</a>
          </li>
          <li className="icon brands fa-facebook-f">
            <a href="#">facebook.com/untitled-tld</a>
          </li>
          <li className="icon brands fa-instagram">
            <a href="#">instagram.com/untitled-tld</a>
          </li> */}
          </ul>
        </div>
      )}
      {activeModal && (
        <div>
          <h3>{activeModal.title}</h3>
          <p>{activeModal.body}</p>
          {activeModal.buttons.map((b, i) => (
            <button key={'button_' + i} onClick={b.callback}>
              {b.text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactForm;
